import RouteReplacingSlots from './RouteReplacingSlots';

export default RouteReplacingSlots;
